import axiosPrivate from "@services/axiosPrivate"
import { ADD_PATIENT } from "src/constants"

export const addPatient = (data) => {
  return axiosPrivate.put(ADD_PATIENT, data, {
    withCredentials: true,
  })
}
